import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import WorkspaceAppResource from './WorkspaceAppResource';
import DateTimeHelper from "../Helpers/DateTimeHelper";
import UserAppResource from "./UserAppResource";
import AgentContactAppResource from "./AgentContactAppResource";
import TransactionWorkspaceAppResource from "./TransactionWorkspaceAppResource";
import LuIntegrationTypeAppResource from "./LuIntegrationTypeAppResource";
import LuTransactionTypeAppResource from "./LuTransactionTypeAppResource";
import OrganizationMemberAppResource from "./OrganizationMemberAppResource";


class TransactionAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'transaction';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'transactions';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'external_transaction_uuid',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'externalTransactionUuid',
            'lookupIntegrationTypeUuid',
            'userUuid',
            'agentContactUuid',
            'lookupTransactionTypeUuid',
            'transactionName',
            'description',
            'stage',
            'address',
            'streetName',
            'streetNumber',
            'unit',
            'city',
            'state',
            'zipCode',
            'sqft',
            'beds',
            'baths',
            'isMlsTransaction',
            'mlsUuid',
            'mlsId',
            'commissionPercentage',
            'commissionFlatFee',
            'targetPrice',
            'minPrice',
            'maxPrice',
            'closingPrice',
            'closingDate',
            'agent',
            'contact',
            'transactionWorkspaces',
            'workspaces',
            'notes',
            'salesVolumeFlatFee',
            'salesVolumePercentage',
            'organizationMembers',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            agent: UserAppResource,
            contact: AgentContactAppResource,
            transactionWorkspaces: TransactionWorkspaceAppResource,
            workspaces: WorkspaceAppResource,
            integrationType: LuIntegrationTypeAppResource,
            transactionType: LuTransactionTypeAppResource,
            organizationMembers: OrganizationMemberAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            agent: 'user_uuid',
            contact: 'agent_contact_uuid',
            integrationType: 'lookup_integration_type_uuid',
            transactionType: 'lookup_transaction_type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            externalTransactionUuid: {
                type: 'string',
            },
            lookupIntegrationTypeUuid: {
                type: 'string',
                presence: true,
            },
            userUuid: {
                type: 'string',
                presence: true,
            },
            agentContactUuid: {
                type: 'string',
            },
            lookupTransactionTypeUuid: {
                presence: true,
                type: 'string',
            },
            transactionName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            stage: {
                presence: true,
                type: 'string',
            },
            description: {
                type: 'string',
            },
            address: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            street_number: {
                type: 'string',
            },
            street_name: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            unit: {
                type: 'string',
            },
            city: {
                type: 'string',
            },
            state: {
                type: 'string',
            },
            sqft: {
                numericality: true,
            },
            beds: {
                type: 'integer',
            },
            baths: {
                numericality: true,
            },
            isMlsTransaction: {
                type: 'boolean',
            },
            mlsUuid: {
                type: 'string',
            },
            mslId: {
                type: 'string',
            },
            commissionFlatFee: {
                numericality: true,
            },
            target_price: {
                numericality: true,
            },
            minPrice: {
                numericality: true,
            },
            maxPrice: {
                numericality: true,
            },
            closingPrice: {
                numericality: true,
            },
            closingDate: {
                datetime: true,
            }
        };
    }

    /**
     * @returns {{closing_date: string}}
     */
    getAPIDatetimeFormat() {
        return {
            closingDate: DateTimeHelper.apiDateTimeFormat,
        }
    }

}

export default TransactionAppResource;
